import { FormattedMessage } from "react-intl";
import type { Customer } from "~types/customer";
import type { StartupItem } from "../../types/startupItem";

const transformCustomer = (customer: Customer): StartupItem => ({
  id: customer.customerId,
  title: customer.displayName,
  subtitle: <FormattedMessage id="customer.customerCode" values={{ code: customer.code }} />,
});

export default transformCustomer;
